import URL from './url'
import http from '@/utils/httpUtils.js'

// 套餐到期
export default {
  // 查询机构即将到期的套餐
  getOrgExpireSku(params) {
    return http.get(URL.API_SCHOOL_MODULE_ORG_EXPIRE_SKU, params)
  },

  // 查询该孩子是否是第三方付费机构且是否已经付费
  getCallPermission(params) {
    return http.get(URL.API_SCHOOL_THIRDPARTY_VERIFY_CALL_PERMISSION, params)
  },
  // H5查询机构即将到期的亲情通话设备
  getExpireDevice(params) {
    return http.get(URL.API_SCHOOL_MODULE_ORG_EXPIRE_VIDEO_DEVICE, params)
  },

  // H5分页查询机构下亲情通话设备
  queryFamilyCallDevice(params) {
    return http.post(URL.API_SQUIRREL_H5_FC_DEVICE, params)
  },

  // H5端查询某个亲情通话机是否有亲情通话权限
  verifyCallEquityByDeviceSn(params) {
    return http.get(URL.API_SQUIRREL_H5_FC_VERIFY_BYSN, params)
  },

  // H5查询新亲情通话套餐设备权益统计数据
  queryVideoEquityStatistics(params) {
    return http.get(URL.API_SQUIRREL_H5_FC_QUERY_STAT, params)
  },
  // 查询免费试用模块
  getFreeModules(params) {
    return http.get(URL.API_GET_FREE_MODULE, params)
  }
}
